export default "__VITE_ASSET__BpFsYfqZ__"